import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import App from "./app.js";
import "./app.css";
import "./index.css";

// Fix for className.split error - polyfill to ensure className.split works safely
if (typeof document !== 'undefined' && typeof window !== 'undefined') {
  // Handle chunk loading errors - reload page if chunks are stale
  window.addEventListener('error', (event) => {
    // Handle ChunkLoadError - happens when chunk files are outdated
    if (event.message && (
      event.message.includes('Loading chunk') ||
      event.message.includes('ChunkLoadError') ||
      event.message.includes('Failed to fetch dynamically imported module')
    )) {
      console.warn('Chunk loading error detected. This usually means the app was updated. Reloading page...');
      // Reload the page to get the latest chunks
      window.location.reload();
      return false;
    }
    
    // Global error handler to catch className.split errors
    if (event.message && event.message.includes('className.split is not a function')) {
      event.preventDefault();
      console.warn('className.split error caught and prevented:', event.message);
      return false;
    }
  }, true);
  
  // Also handle unhandled promise rejections for chunk loading
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && (
      event.reason.message?.includes('Loading chunk') ||
      event.reason.message?.includes('ChunkLoadError') ||
      event.reason.name === 'ChunkLoadError'
    )) {
      console.warn('Chunk loading error detected in promise rejection. Reloading page...');
      event.preventDefault();
      window.location.reload();
    }
  });

  // Patch to ensure className is always a string when accessed
  try {
    const originalGetAttribute = Element.prototype.getAttribute;
    Element.prototype.getAttribute = function(name) {
      if (name === 'class' || name === 'className') {
        const value = originalGetAttribute.call(this, name);
        if (value && typeof value !== 'string') {
          return String(value) || '';
        }
        return value || '';
      }
      return originalGetAttribute.call(this, name);
    };
  } catch (e) {
    // If patching fails, continue without it
    console.warn('Could not patch Element.prototype.getAttribute:', e);
  }
}

// Error boundary for app initialization
try {
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error("Root element not found. Make sure index.html has <div id='root'></div>");
  }

  const root = ReactDOM.createRoot(rootElement);
  root.render(
    // <React.StrictMode>
    //   <Provider store={store}>
    //     <App />
    //   </Provider>
    // </React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
  );
} catch (error) {
  console.error("❌ CRITICAL: Failed to initialize React app:", error);
  console.error("Error details:", error.message, error.stack);
  
  // Display error message in the root element
  const rootElement = document.getElementById("root");
  if (rootElement) {
    rootElement.innerHTML = `
      <div style="padding: 20px; font-family: Arial, sans-serif;">
        <h1>Application Error</h1>
        <p>The application failed to initialize. Please check the browser console for details.</p>
        <p><strong>Error:</strong> ${error.message}</p>
        <button onclick="window.location.reload()" style="padding: 10px 20px; margin-top: 10px;">
          Reload Page
        </button>
      </div>
    `;
  }
}

